import { Component, Input, Output, EventEmitter, HostListener, ViewEncapsulation } from '@angular/core';
import template from '../../template-angular/comparison-editions/comparison-editions-select.component.html';
@Component({
  selector: 'app-comparison-editions-select',
  template,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ComparisonEditionsSelectComponent {
  @Input() mode: 'single' | 'multiple' = 'multiple'; // Режим работы
  @Input() units: any[] = [];
  @Input() hasOneCheckboxChecked: boolean = false;

  @Output() selectionChange = new EventEmitter<any>();
  @Output() apply = new EventEmitter<any[]>();
  @Input() selectedItem: any = null;

  isOpen: boolean = false;
  selectedItems: any[] = []; // Для multiple mode

  isSelected(unit: any): boolean {
    if (this.mode === 'single') {
      return this.selectedItem?.id === unit.id;
    } else {
      return this.selectedItems?.some(item => item.id === unit.id);
    }
  }

  // Для multiple mode - toggle чекбокса
  toggleItem(unit: any, event: any): void {
    if (this.mode !== 'multiple') return;

    const checked = event.target.checked;

    if (checked) {
      this.selectedItems = [...(this.selectedItems || []), unit];
    } else {
      this.selectedItems = this.selectedItems?.filter(item => item.id !== unit.id);
    }

    this.selectionChange.emit(this.selectedItems);
  }

  // Для single mode - выбор элемента
  selectItem(unit: any): void {
    if (this.mode !== 'single') return;

    // Проверка на disabled
    if (this.hasOneCheckboxChecked && this.isSelected(unit)) {
      return;
    }

    this.selectedItem = unit;
    this.selectionChange.emit(unit);
    // Закрываем дропдаун после выбора в single mode
    this.isOpen = false;
  }

  // Для multiple mode - применение выбранных редакций
  onApplyEditions(): void {
    if (this.mode !== 'multiple') return;

    this.apply.emit(this.selectedItems);
    this.isOpen = false;
  }

  // Очистить все выбранные элементы
  clearSelection(): void {
    if (this.mode === 'single') {
      this.selectedItem = null;
      this.selectionChange.emit(null);
    } else {
      this.selectedItems = [];
      this.selectionChange.emit([]);
    }
  }

  // Установить выбранные элементы программно
  setSelection(items: any | any[]): void {
    if (this.mode === 'single') {
      this.selectedItem = items;
    } else {
      this.selectedItems = Array.isArray(items) ? items : [items];
    }
  }

  // Получить текущие выбранные элементы
  getSelection(): any | any[] {
    return this.mode === 'single' ? this.selectedItem : this.selectedItems;
  }

  toggleDropdown(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.isOpen = !this.isOpen;
  }

  // Закрыть дропдаун при клике вне
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.comparison-editions__select')) {
      this.isOpen = false;
    }
  }
}
